<template>
  <v-dialog v-model="showModal" width="500">
    <v-card>
      <v-toolbar card dark color="primary">
        <v-toolbar-title>
          <v-icon>info</v-icon>
            Send Email Test
          </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark @click="$emit('close-modal-send-email-test')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text>
        <v-text-field label="Name"
          v-model="name"
          v-validate="'required|max:75'"
          :error-messages="errors.collect('name')"
          data-vv-name="name"
        ></v-text-field>
        <v-text-field
          label="E-mail"
          v-model="email"
          v-validate="'required|email|max:190'"
          :error-messages="errors.collect('email')"
          data-vv-name="email"
        ></v-text-field>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat @click="$emit('close-modal-send-email-test')">
          CLOSE
        </v-btn>
        <v-btn color="primary" @click="sendEmail">
          SEND
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    round: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      email: '',
      name: ''
    };
  },
  methods: {
    ...mapActions(['setSnackbar', 'setLoading']),
    sendEmail () {
      this.$validator.validateAll().then(result => {
        if (result) {
          const payload = {
            round_id: this.round.id,
            name: this.name,
            email: this.email
          };
          this.setLoading(true);
          const url = 'rounds/' + this.round.id + '/send-email-test';
          window.axios.post(url, payload).then(response => {
            this.setLoading(false);
            this.setSnackbar({
              show: true,
              color: 'success',
              text: 'Mail sent correctly, please check your inbox.'
            });
            this.$emit('close-modal-send-email-test');
          }).catch(error => {
            this.setSnackbar({
              show: true,
              color: 'red',
              text: 'Mail sent Error, please check Info'
            });
            this.setLoading(false);
          });
        } else {
          this.setSnackbar({
            show: true,
            color: 'info',
            text: 'Check the form, please.'
          });
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/client/rounds/modals/EmailTest.vue